// extracted by mini-css-extract-plugin
module.exports = {"pageError":"style_pageError__O0QtK","artwork":"style_artwork__bFj1j","btn":"style_btn__xuXY2"};